import Modal from './Modal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalActions from './ModalActions'
import ModalLegacy from './ModalLegacy'
import useModal from './useModal'

// Exporter Modal avec ses sous-composants et hooks
export default Object.assign(Modal, {
  Header: ModalHeader,
  Body: ModalBody,
  Actions: ModalActions,
  Legacy: ModalLegacy,
  useModal
})

// Exporter individuellement pour les imports nommés
export { Modal, ModalHeader, ModalBody, ModalActions, ModalLegacy, useModal }